import { Eye, EyeOff, Maximize2 } from "lucide-react";

interface LiveScreenshotToolbarProps {
  hasHighlights: boolean;
  showHighlights: boolean;
  onToggleHighlights: () => void;
  onOpenZoom: () => void;
}

export function LiveScreenshotToolbar({
  hasHighlights,
  showHighlights,
  onToggleHighlights,
  onOpenZoom,
}: LiveScreenshotToolbarProps) {
  return (
    <div className="absolute top-3 right-3 z-10 flex items-center gap-1.5 opacity-90 transition-opacity sm:opacity-0 sm:group-hover:opacity-100 sm:group-focus-within:opacity-100">
      {hasHighlights && (
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            onToggleHighlights();
          }}
          className="inline-flex items-center gap-1 rounded bg-background/90 px-2 py-1 text-xs font-medium text-foreground shadow-xs backdrop-blur-xs transition-colors hover:bg-background focus-visible:outline-2 focus-visible:outline-ring"
          title={
            showHighlights ? "Hide annotations (H)" : "Show annotations (H)"
          }
          aria-label={showHighlights ? "Hide annotations" : "Show annotations"}
        >
          {showHighlights ? (
            <Eye className="h-3 w-3 text-primary" aria-hidden="true" />
          ) : (
            <EyeOff
              className="h-3 w-3 text-muted-foreground"
              aria-hidden="true"
            />
          )}
          <span>{showHighlights ? "Annotations on" : "Clean"}</span>
          <kbd className="hidden sm:inline-block rounded border border-border bg-muted px-1 font-mono text-xs text-muted-foreground">
            H
          </kbd>
        </button>
      )}

      <button
        type="button"
        onClick={(e) => {
          e.stopPropagation();
          onOpenZoom();
        }}
        className="inline-flex items-center gap-1 rounded bg-background/90 px-2 py-1 text-xs font-medium text-foreground shadow-xs backdrop-blur-xs transition-colors hover:bg-background focus-visible:outline-2 focus-visible:outline-ring"
        title="Enlarge screenshot"
        aria-label="Enlarge screenshot"
      >
        <Maximize2 className="h-3 w-3" aria-hidden="true" />
        <span>Enlarge</span>
      </button>
    </div>
  );
}
